import { rpcClient } from 'src/utils/api';

export const registerFcmAPI = (regId: string) => {
  return rpcClient<[string], void>('registerFcm')([regId]);
};
